import { FunctionComponent, useContext } from 'react';
import { UserContext } from '../../context';
import { NewsletterConsentScreen, useMeNewsletterConsentsQuery } from '../../services';
import { BackButton, NewsletterConsent, useIsNewslettersAllowed } from '../../shared';
import { NoContent } from '../Error';

import classes from './Newsletters.module.scss';

export const Newsletters: FunctionComponent = () => {
  const { isAnonymous } = useContext(UserContext).userProfile;

  const { isLoading } = useMeNewsletterConsentsQuery(undefined, { skip: isAnonymous });

  const isNewslettersAllowed = useIsNewslettersAllowed();

  if (isLoading) {
    return null;
  }

  if (!isNewslettersAllowed) {
    return <NoContent />;
  }

  return (
    <div className={classes['newsletters']}>
      <BackButton />
      <NewsletterConsent screen={NewsletterConsentScreen.SETTINGS} />
    </div>
  );
};
